import file from './file';
import string from './string';
import query from './query';
import env from './env';
import wx from './wx';
import alipay from './alipay';

export default {
    file,
    string,
    query,
    env,
    wx,
    alipay,
    delay(ms) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    },
};
